import { startOfMonth, endOfMonth, startOfYear, endOfYear, subDays, subMonths } from 'date-fns';

export const getDatePreset = (presetKey) => {
  const today = new Date();
  switch (presetKey) {
    case 'last7':
      return [subDays(today, 6), today];
    case 'last30':
      return [subDays(today, 29), today];
    case 'last90':
      return [subDays(today, 89), today];
    case 'thisMonth':
      return [startOfMonth(today), endOfMonth(today)];
    case 'lastMonth':
      return [startOfMonth(subMonths(today, 1)), endOfMonth(subMonths(today, 1))];
    case 'thisYear':
      return [startOfYear(today), endOfYear(today)];
    default:
      return null;
  }
};